/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import {
  Container,
  Pagination,
  Box,
  SelectChangeEvent,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button,
} from "@mui/material";
import TableHorizontal from "../../../components/TableHorizontal";
import api from "../../../services/api";
function ListAttributeGroups() {
  const [pageState, setPageState] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [users, setUsers] = useState([]);
  const columns = ["ID", "Name", "Actions", "Delete"];
  const keys = ["id", "name", "action", "delete"];
  const fetchData = async (
    page = 1,
    language = 1,
    numberItemsPerPage = 500
  ) => {
    await api
      .get(
        `/attribute-groups?page=${page}&limit=${numberItemsPerPage}&language_id=${language}&search=${search}`
      )
      .then((res) => {
        setUsers(res.data.items);
        setTotalPages(res.data.total_pages);
      });
  };
  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPageState(value);
    fetchData(value, Number(language), Number(numberItemsPerPage));
  };

  const [search, setSearch] = useState("");
  const handleChangeSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  const [numberItemsPerPage, setNumberItemsPerPage] = useState("500");
  const handleNumberItemsPerPage = (event: SelectChangeEvent) => {
    setNumberItemsPerPage(event.target.value);
    fetchData(1, Number(language), Number(event.target.value));
  };

  const [language, setLanguage] = useState('0');
  const handleChangeLanguage = (event: SelectChangeEvent) => {
    setLanguage(event.target.value);
    fetchData(1, Number(event.target.value), Number(numberItemsPerPage));
  };

  const [languages, setLanguages] = useState<{ id: number; name: string }[]>(
    []
  );
  const fetchLanguages = async () => {
    const response = await api.get(`languages`);
    setLanguages(response.data.items);
    setLanguage('1');
  };

  const handleSearchClick = () => {
    fetchData(1, Number(language));
  };

  useEffect(() => {
    fetchData();
    fetchLanguages();
  }, []);
  return (
    <Container maxWidth="lg" sx={{ mt: 2, mb: 4 }}>
      <Box style={{ display: "flex", flexDirection:"row" }}>
        <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          marginRight: "8px",
          marginLeft: 1,
        }}
        >
      <InputLabel id="number-items-page-label">
        Number of Items per Page
      </InputLabel>
      <Select
        labelId="number-items-page-select-label"
        id="number-items-page"
        value={numberItemsPerPage}
        label="Number of Items per Page"
        onChange={handleNumberItemsPerPage}
      >
        <MenuItem value={100}>100</MenuItem>
        <MenuItem value={250}>250</MenuItem>
        <MenuItem value={500}>500</MenuItem>
        <MenuItem value={750}>750</MenuItem>
        <MenuItem value={1000}>1000</MenuItem>
      </Select>
      </Box>
      <Box
       sx={{
        display: "flex",
        flexDirection: "column",
      }}
      >
      <InputLabel id="language-label">Language</InputLabel>
      <Select
        labelId="language-select-label"
        id="language"
        value={language}
        label="Language"
        onChange={handleChangeLanguage}
      >
        <MenuItem value={0}>None</MenuItem>
        {languages.map((language, index) => (
          <MenuItem key={index} value={language.id}>{language.name}</MenuItem>
        ))}
      </Select>
      </Box>
      <Box
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
      >
        <InputLabel id="table-name-filter-label">
      Table Name filter
      </InputLabel>
      <TextField
        //sx={{ mt: 1, minWidth: 3/4 }}
        sx={{ minWidth: 1 / 4, marginLeft: "8px" }}
        //fullWidth
        id={"Table-name"}
        type="text"
        label="Type here"
        value={search}
        onChange={handleChangeSearch}
      />
      </Box>
      <Button
        variant="contained"
        sx={{ m: 3 }}
        href=""
        onClick={handleSearchClick}
      >
        Filter
      </Button>
      </Box>
      <TableHorizontal
        screen={"attribute-groups"}
        columns={columns}
        data={users}
        objectKey={keys}
      />
      <Box
        display="flex"
        width={"100%"}
        height={80}
        alignItems="center"
        justifyContent="center"
      >
        <Pagination
          count={totalPages}
          page={pageState}
          onChange={handleChange}
        />
      </Box>
    </Container>
  );
}
export default ListAttributeGroups;
